var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallGatewayIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 49.24 72.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke: #dedddd;\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-15, .cls-3, .cls-4, .cls-16, .cls-17, .cls-5 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-15, .cls-4, .cls-16, .cls-17, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-15, .cls-4 {\n        stroke-width: .07px;\n      }\n\n      .cls-15, .cls-4, .cls-16, .cls-17, .cls-5 {\n        stroke: #010101;\n      }\n\n      .cls-15, .cls-16, .cls-17, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: url(#New_Pattern_Swatch_3);\n        opacity: .3;\n      }\n\n      .cls-3 {\n        stroke: #26a54a;\n        stroke-miterlimit: 10;\n        stroke-width: .67px;\n      }\n\n      .cls-8 {\n        fill: #139948;\n        opacity: .26;\n      }\n\n      .cls-8, .cls-18, .cls-19 {\n        isolation: isolate;\n      }\n\n      .cls-16 {\n        stroke-width: .08px;\n      }\n\n      .cls-18 {\n        fill: #231f20;\n        font-family: HelveticaNeueLTPro-Bd, 'Helvetica Neue LT Pro';\n        font-size: 2.04px;\n      }\n\n      .cls-17, .cls-5 {\n        stroke-width: .09px;\n      }\n\n      .cls-9 {\n        fill: #2aace2;\n      }\n\n      .cls-10 {\n        fill: #26a54a;\n      }\n\n      .cls-11 {\n        fill: #cccbcb;\n      }\n\n      .cls-12 {\n        fill: #e39793;\n      }\n\n      .cls-14 {\n        fill: #010101;\n      }\n    "), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern_Swatch_3",
    "data-name": "New Pattern Swatch 3",
    x: 0,
    y: 0,
    width: 13.51,
    height: 13.52,
    patternTransform: "translate(0 72.49)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 13.51 13.52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 13.51,
    height: 13.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: ".71 0 0 .71 0 0 .71 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "4.09 0 0 4.09 0 2.67 2.67 0 4.09 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "7.46 0 0 7.47 0 6.05 6.05 0 7.46 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "10.84 0 0 10.85 0 9.43 9.43 0 10.84 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.51 0 13.51 .71 .71 13.52 0 13.52 0 12.81 12.81 0 13.51 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.51 2.68 13.51 4.09 4.09 13.52 2.67 13.52 13.51 2.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.51 6.06 13.51 7.47 7.46 13.52 6.05 13.52 13.51 6.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.51 9.43 13.51 10.85 10.83 13.52 9.43 13.52 13.51 9.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "12.81 13.52 13.51 12.81 13.51 13.52 12.81 13.52"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.93,
    y1: 55.16,
    x2: 29.99,
    y2: 54.21,
    gradientTransform: "translate(0 73.32) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19c1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009dcf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4.54,
    y: 43.7,
    width: 43.33,
    height: 27.92
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.86,
    y1: 72.12,
    x2: 2.27,
    y2: 72.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 4.54,
    y: 1.25,
    width: 43.33,
    height: 42.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.54,
    y1: 43.7,
    x2: 20.17,
    y2: 43.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.54,
    y1: 1.25,
    x2: 20.17,
    y2: 1.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M33.67,68.72v-1.82c0-.21-.17-.39-.39-.39h-1.85c-.21,0-.39.17-.39.39v1.85c0,.21.17.39.39.39h1.82c.23,0,.41-.18.41-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.56,67.15c.29.09.5.35.5.66,0,.38-.3.69-.69.69s-.69-.31-.69-.69c0-.3.2-.56.47-.65"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(0 43.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2m"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(0 1.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5m"))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "32.56 67.53 32.64 67.53 32.85 67.84 32.65 68.1 32.07 68.1 31.85 67.84 32.05 67.53 32.11 67.53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M25.65,24.66c0,.18.14.32.32.32s.32-.14.32-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.31,24.66c0,.18.14.32.32.32s.32-.14.32-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.97,24.66c0,.18.14.32.32.32s.32-.14.32-.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.43,16.22h-.03l-.04.05v.02l-.03.02v.03l-.02.03v7.91s.01.03.01.03l.03.02v.02l.04.02h.02l.03.03.68.25v-8.66l-.68.25v-.02ZM23.62,16.67l.02-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.12l-.04.03-.03.03-.04.02h-.08l-.04-.02-.03-.03-.02-.03v-.04l-.02-.04v-.04ZM23.91,23.91v.04l-.04.03-.03.03h-.04l-.04.02h-.04l-.04-.02-.03-.03-.02-.03v-.04l-.02-.04v-.04l.03-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.08h-.01ZM23.93,20.3h0v.03h0v.03h0v.02h0v.02h0v.02h-.01v.02s-.01.16-.01.16h0v.02h0v.02h0v.02h-.01s-.01.01-.01.01h-.06v-.02h0v-.03h0v-.18h-.01v-.02h-.01v-.02h0v-.02h0v-.02h0v-.03h0v-.05h0v-.03h0v-.03h0v-.02h0v-.02h0v-.02h.02v-.18h0v-.02h0v-.02h0v-.02h.08v.02h0v.02h0v.02h0v.17h.01s.01.01.01.01v.02h0v.02h0v.02h0v.03h0v.03h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.37,15.95h-13.17l-.06.02v8.66l.06.02h13.15l.06-.02v-8.66l-.06-.02h.02ZM36.25,22.92c0,.23-.19.42-.42.42h-10.13c-.23,0-.42-.19-.42-.42v-5.23c0-.23.19-.42.42-.42h10.13c.23,0,.42.19.42.42v5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.23,16.36v-.06s0-.02,0-.02l-.03-.02-.04-.04h-.03l-.68-.26v8.66l.68-.25h.03l.02-.03.02-.02.02-.02v-.02l.03-.03v-7.91.02ZM37.65,16.67l.02-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.12l-.04.03-.03.03-.04.02h-.08l-.04-.02-.03-.03-.03-.03v-.08s0-.04-.01-.04ZM37.93,23.91v.04l-.04.03-.03.03h-.04l-.04.02h-.04l-.04-.02-.03-.03-.03-.03v-.08s0-.04,0-.04l.03-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.08h-.01ZM37.96,20.3h0v.03h0v.03h0v.03h0v.02h0v.02h0v.02s0,.16,0,.16h0v.02h0v.02h0v.02h0s0,.01,0,.01h-.05s-.02-.04-.02-.04h0v-.02h0v-.18h0v-.02h0v-.02h0v-.02h0v-.03h0v-.03h0v-.05h0v-.03h0v-.03h0v-.02h0l.03-.04h0v-.17h0v-.02h0v-.02h0v-.02h.09v.02h0v.03h0v.18h0v.02h0v.02h0v.02h0v.03h0v.02h0v.03h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M35.84,17.26h-10.13c-.23,0-.42.19-.42.42v5.23c0,.23.19.42.42.42h10.13c.23,0,.42-.19.42-.42v-5.23c0-.23-.19-.42-.42-.42ZM34.03,20.63h.49v.49h-.49v-.49ZM33.49,22.14h-.49v-.49h.49v.49ZM33.49,21.13h-.49v-.49h.49v.49Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "32.56 20.54 32.56 20.18 32.91 20.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "32.91 22.56 32.56 22.56 32.56 22.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "34.94 22.24 34.94 22.56 34.6 22.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "34.6 20.18 34.94 20.18 34.94 20.54"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.25,
    x2: 27.04,
    y2: 21.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.59,
    x2: 28.67,
    y2: 21.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.94,
    x2: 27.68,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 22.28,
    x2: 28.36,
    y2: 22.28
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 33,
    y: 20.63,
    width: 0.49,
    height: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 33,
    y: 21.64,
    width: 0.49,
    height: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 34.03,
    y: 20.63,
    width: 0.49,
    height: 0.49
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M31.34,18.94v-.61h.06l.24.56.24-.56h.06v.61h-.04v-.55l-.23.54h-.05l-.23-.54v.55h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.1,18.94v-.61h.04v.61h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.66,18.93l-.31-.55v.55h-.04v-.61h.06l.31.55v-.56h.04v.61h-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.87,18.94v-.61h.13c.22,0,.31.13.31.31s-.1.31-.31.31h-.13ZM33,18.9c.19,0,.27-.1.27-.27s-.08-.27-.27-.27h-.08v.53h.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28.47,18.6l-.05-.03c-.08-.04-.11-.06-.11-.12,0-.03.01-.05.03-.07s.05-.03.08-.03c.06,0,.1.02.13.07h.03c-.04-.08-.09-.1-.16-.1-.09,0-.15.06-.15.14s.05.12.13.15l.05.03c.09.04.12.08.12.15,0,.03-.01.06-.04.08-.02.02-.06.03-.11.03-.07,0-.13-.04-.16-.1h-.04c.04.09.11.13.2.13h0c.11,0,.18-.06.18-.15,0-.08-.04-.13-.14-.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "29.13 18.33 29.08 18.33 28.8 18.69 28.8 18.33 28.76 18.33 28.76 18.93 28.8 18.93 28.8 18.75 28.87 18.66 29.1 18.93 29.16 18.93 28.9 18.63 29.13 18.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M29.66,18.33l-.2.37-.2-.37h-.05l.23.42v.19h.04v-.19l.23-.42h-.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.47,17.98c-.35,0-.63.27-.65.61v.04c0,.36.29.65.65.65s.63-.27.65-.62v-.03c0-.36-.29-.65-.65-.65ZM30.8,18.67v.17l-.33.18-.33-.18v-.41l.33-.18.33.18v.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 33.98,
    y: 21.6,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.42,
    y: 21.6,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 33.98,
    y: 22.02,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.42,
    y: 22.02,
    width: 0.16,
    height: 0.16
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.2,
    y: 21.81,
    width: 0.16,
    height: 0.16
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 31.7,
    y: 24.66,
    width: 1.3,
    height: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M31.79,25.1h1.12v.56c0,.08-.06.14-.14.14h-.84c-.08,0-.14-.06-.14-.14v-.56h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.43,16.22h-.03l-.04.05v.02l-.03.02v.03l-.02.03v7.91s.01.03.01.03l.03.02v.02l.04.02h.02l.03.03.68.25v-8.66l-.68.25v-.02ZM23.62,16.67l.02-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.12l-.04.03-.03.03-.04.02h-.08l-.04-.02-.03-.03-.02-.03v-.04l-.02-.04v-.04ZM23.91,23.91v.04l-.04.03-.03.03h-.04l-.04.02h-.04l-.04-.02-.03-.03-.02-.03v-.04l-.02-.04v-.04l.03-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.08h-.01ZM23.93,20.3h0v.03h0v.03h0v.02h0v.02h0v.02h-.01v.02s-.01.16-.01.16h0v.02h0v.02h0v.02h-.01s-.01.01-.01.01h-.06v-.02h0v-.03h0v-.18h-.01v-.02h-.01v-.02h0v-.02h0v-.02h0v-.03h0v-.05h0v-.03h0v-.03h0v-.02h0v-.02h0v-.02h.02v-.18h0v-.02h0v-.02h0v-.02h.08v.02h0v.02h0v.02h0v.17h.01s.01.01.01.01v.02h0v.02h0v.02h0v.03h0v.03h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.37,15.95h-13.17l-.06.02v8.66l.06.02h13.15l.06-.02v-8.66l-.06-.02h.02ZM36.25,22.92c0,.23-.19.42-.42.42h-10.13c-.23,0-.42-.19-.42-.42v-5.23c0-.23.19-.42.42-.42h10.13c.23,0,.42.19.42.42v5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.23,16.36v-.06s0-.02,0-.02l-.03-.02-.04-.04h-.03l-.68-.26v8.66l.68-.25h.03l.02-.03.02-.02.02-.02v-.02l.03-.03v-7.91.02ZM37.65,16.67l.02-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.12l-.04.03-.03.03-.04.02h-.08l-.04-.02-.03-.03-.03-.03v-.08s0-.04-.01-.04ZM37.93,23.91v.04l-.04.03-.03.03h-.04l-.04.02h-.04l-.04-.02-.03-.03-.03-.03v-.08s0-.04,0-.04l.03-.04.03-.03.04-.02h.08s.04-.01.04-.01l.04.03.03.03.02.04v.08h-.01ZM37.96,20.3h0v.03h0v.03h0v.03h0v.02h0v.02h0v.02s0,.16,0,.16h0v.02h0v.02h0v.02h0s0,.01,0,.01h-.05s-.02-.04-.02-.04h0v-.02h0v-.18h0v-.02h0v-.02h0v-.02h0v-.03h0v-.03h0v-.05h0v-.03h0v-.03h0v-.02h0l.03-.04h0v-.17h0v-.02h0v-.02h0v-.02h.09v.02h0v.03h0v.18h0v.02h0v.02h0v.02h0v.03h0v.02h0v.03h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M35.84,17.26h-10.13c-.23,0-.42.19-.42.42v5.23c0,.23.19.42.42.42h10.13c.23,0,.42-.19.42-.42v-5.23c0-.23-.19-.42-.42-.42ZM34.03,20.63h.49v.49h-.49v-.49ZM33.49,22.14h-.49v-.49h.49v.49ZM33.49,21.13h-.49v-.49h.49v.49Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "32.56 20.54 32.56 20.18 32.91 20.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "32.91 22.56 32.56 22.56 32.56 22.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "34.94 22.24 34.94 22.56 34.6 22.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "34.6 20.18 34.94 20.18 34.94 20.54"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.25,
    x2: 27.04,
    y2: 21.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.59,
    x2: 28.67,
    y2: 21.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 21.94,
    x2: 27.68,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.14,
    y1: 22.28,
    x2: 28.36,
    y2: 22.28
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 33,
    y: 20.63,
    width: 0.49,
    height: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 33,
    y: 21.64,
    width: 0.49,
    height: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 34.03,
    y: 20.63,
    width: 0.49,
    height: 0.49
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M31.34,18.94v-.61h.06l.24.56.24-.56h.06v.61h-.04v-.55l-.23.54h-.05l-.23-.54v.55h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.1,18.94v-.61h.04v.61h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.66,18.93l-.31-.55v.55h-.04v-.61h.06l.31.55v-.56h.04v.61h-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.87,18.94v-.61h.13c.22,0,.31.13.31.31s-.1.31-.31.31h-.13ZM33,18.9c.19,0,.27-.1.27-.27s-.08-.27-.27-.27h-.08v.53h.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28.47,18.6l-.05-.03c-.08-.04-.11-.06-.11-.12,0-.03.01-.05.03-.07s.05-.03.08-.03c.06,0,.1.02.13.07h.03c-.04-.08-.09-.1-.16-.1-.09,0-.15.06-.15.14s.05.12.13.15l.05.03c.09.04.12.08.12.15,0,.03-.01.06-.04.08-.02.02-.06.03-.11.03-.07,0-.13-.04-.16-.1h-.04c.04.09.11.13.2.13h0c.11,0,.18-.06.18-.15,0-.08-.04-.13-.14-.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "29.13 18.33 29.08 18.33 28.8 18.69 28.8 18.33 28.76 18.33 28.76 18.93 28.8 18.93 28.8 18.75 28.87 18.66 29.1 18.93 29.16 18.93 28.9 18.63 29.13 18.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M29.66,18.33l-.2.37-.2-.37h-.05l.23.42v.19h.04v-.19l.23-.42h-.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.47,17.98c-.35,0-.63.27-.65.61v.04c0,.36.29.65.65.65s.63-.27.65-.62v-.03c0-.36-.29-.65-.65-.65ZM30.8,18.67v.17l-.33.18-.33-.18v-.41l.33-.18.33.18v.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 33.98,
    y: 21.6,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.42,
    y: 21.6,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 33.98,
    y: 22.02,
    width: 0.16,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.42,
    y: 22.02,
    width: 0.16,
    height: 0.16
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.2,
    y: 21.81,
    width: 0.16,
    height: 0.16
  })))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "32.08 67.6 32.08 25.84 32.61 25.84 32.61 67.6"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 39.52,
    cy: 29.11,
    r: 3.27
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "38.01 28.78 39.37 30.14 43.55 25.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallGatewayIllustration);
export default __webpack_public_path__ + "static/media/install_gateway_Illustration.8d3e97812342985a02ef0380a04d1639.svg";
export { ForwardRef as ReactComponent };